<template>
  <div>
    <!-- Page Title -->
    <page-title icon="ni ni-tv-2" main="Paineis" :sub="dashboard.title">
      <template v-slot:actions>
        <base-button
          v-if="can.updateDash"
          type="neutral"
          class="ml-3"
          size="sm"
          @click="modals.dashboard = true"
        >Editar Painel</base-button>
        <base-button
          v-if="can.updateItem"
          type="neutral"
          class="ml-3"
          size="sm"
          @click="addDashboardItem"
        >Novo Item</base-button>
        <base-button
          v-if="can.destroyDash"
          type="danger"
          class="ml-3"
          size="sm"
          @click="deleteDashboard"
        >Excluir Painel</base-button>
        <base-button
          v-if="layoutChanged"
          type="success"
          class="ml-3"
          size="sm"
        >Salvar Layout</base-button>
      </template>
    </page-title>

    <!-- Modals -->
    <modal :show.sync="modals.dashboard" size="lg">
      <template slot="header">
        <h5 class="modal-title">Editar Painel</h5>
      </template>

      <base-input
        v-model="dashboard.title"
        label="Titulo"
        placeholder="Ex: Vendedores" />
      <base-input
        label="Descrição">
        <textarea class="form-control" v-model="dashboard.description" rows="3"></textarea>
      </base-input>

      <template slot="footer">
        <base-button type="secondary" @click="newDashboardModal = false">Fechar</base-button>
        <base-button type="success" @click="saveDashboard">Salvar</base-button>
      </template>
    </modal>

    <modal :show.sync="modals.dashboardItem" size="xl">
      <template slot="header">
        <h5 class="modal-title">{{formDashboardItem.id ? 'Editar' : 'Adicionar'}} Item do Painel</h5>
      </template>

      <dashboard-item-form :dashboardItem.sync="formDashboardItem" />

      <template slot="footer">
        <base-button type="secondary" @click="modals.dashboardItem = false">Fechar</base-button>
        <base-button type="success" @click="saveDashboardItem">Salvar</base-button>
      </template>
    </modal>

    <!-- Page Content -->
    <!-- <grid-layout
        :cols="{ lg: 6, md: 4, sm: 2, xs: 1, xxs: 1 }"
        :layout="layout"
        :col-num="6"
        :row-height="100"
        :max-rows="10"
        :is-draggable="true"
        :is-resizable="true"
        :vertical-compact="true"
        :responsive="true"
        :use-css-transforms="true">
      <grid-item
        :is-resizable="can.updateItem"
        v-for="item in layout" :key="item.i"
        drag-allow-from=".handle"
        :x="item.x"
        :y="item.y"
        :w="item.w"
        :h="item.h"
        :i="item.i"
        @moved="movedEvent"
        @resized="resizedEvent">
        <dashboard-item-card :dashboard-item="item.item" />
      </grid-item>
    </grid-layout> -->
    <div class="row">
      <div class="col-6" v-for="item in dashboardItems" :key="item.id" style="height: 300px; margin-bottom: 25px;">
        <dashboard-item-card :dashboard-item="item" :disabledActions="true" />
      </div>
    </div>
  </div>

</template>
<script>
  import PageTitle from "@/layouts/PageTitle";
  import { GridLayout, GridItem } from "vue-grid-layout";
  import DashboardItemCard from './DashboardItemCard';
  import DashboardItemForm from './DashboardItemForm'

  export default {
    components: {
      PageTitle,
      GridItem,
      GridLayout,
      DashboardItemCard,
      DashboardItemForm,
    },
    data() {
      return {
        can: {
          updateItem: false,
          updateDash: false,
          destroyDash: false
        },
        modals: {
          dashboard: false,
          dashboardItem: false,
        },
        lastUpdate: '',
        layoutChanged: false,
        dashboard: {},
        dashboardItems: [],
        formDashboardItem: {},
      };
    },
    methods: {
      initDashboard() {
        const dashId = this.$route.params.id
        this.$http.secured.get('/api/v1/dashboards/' + dashId)
            .then(response => {
              this.dashboard = response.data
              this.initDashboardItems()
            })
      },
      initDashboardItems() {
        this.$http.secured.get(`/api/v1/dashboards/${this.dashboard.id}/dashboard_items`)
            .then(response => {
              this.dashboardItems = response.data
              // this.dashboardItems = Object.assign({}, this.dashboardItems, response.data)
              // response.data.forEach((item, index) => this.$set(this.dashboardItems, index, item))
              // this.dashboardItems.splice(0, 999999, ...response.data)
            })
      },
      addDashboardItem() {
        this.formDashboardItem = {}
        this.modals.dashboardItem = true
      },
      saveDashboard() {
         this.$http.secured
             .patch('/api/v1/dashboards/' + this.dashboard.id, {dashboard: this.dashboard})
             .then(() => this.modals.dashboard = false)
      },
      deleteDashboard() {
        this.$http.secured
            .delete('/api/v1/dashboards/' + this.dashboard.id)
            .then(() => this.$router.replace({ name: 'Geral' }))
      },
      saveDashboardItem() {
        Object.assign(this.formDashboardItem, {x: 0, y: 999999, width: 2, height: 2})
        this.$http.secured
            .post(`/api/v1/dashboards/${this.dashboard.id}/dashboard_items`, {dashboard_item: this.formDashboardItem})
            .then(response => {
              this.formDashboardItem = response.data
              this.dashboardItems.push(this.formDashboardItem)
              this.modals.dashboardItem = false
            })
      },
      resizedEvent: function(i, newH, newW){
        const resizedItem = this.dashboardItems.find(item => item.id === i)
        resizedItem.height = newH
        resizedItem.width  = newW

        this.layoutChanged = true
        this.$forceUpdate()
      },
      movedEvent: function(i, newX, newY){
        const resizedItem = this.dashboardItems.find(item => item.id === i)
        resizedItem.x = newX
        resizedItem.y = newY

        this.layoutChanged = true
        this.$forceUpdate()
      },
    },
    computed: {
      layout: {
        get() {
          return this.dashboardItems.map(item => {
            return {
              x: item.x,
              y: item.y,
              w: item.width,
              h: item.height,
              i: item.id,
              item: item,
            }
          })
        },
        set(newLayout){
          this.lastUpdate = Date.now()

          newLayout.forEach((item, index) => this.$set(this.dashboardItems, index, Object.assign(
            this.dashboardItems[index],
            {x: item.x, y: item.y}
          )))

          this.$forceUpdate();
        },
      },
    },
    mounted() {
      this.initDashboard()
      this.can.updateItem  = !!this.$can('update', 'dashboard_item')
      this.can.updateDash  = this.$can('update', 'dashboard')
      this.can.destroyDash = this.$can('destroy', 'dashboard')
    },
  };
</script>
<style></style>
